import script from "./OrganisationPreviewDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganisationPreviewDrawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__